import styled from '@emotion/styled'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import 'bootstrap/dist/css/bootstrap.min.css'
import { ToastContainer } from 'react-toastify'
import './assets/theme.css'
import catchError from './components/global/CatchError'
import Router from './components/global/Router'
import { MenuProvider } from './context/MenuContext'
import UserContextProvider from './context/UserContextProvider'
import './i18n/translation'

function App() {
    return (
        <UserContextProvider>
            <MenuProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MainContainer>
                        <Router />
                        <ToastContainer />
                    </MainContainer>
                </LocalizationProvider>
            </MenuProvider>
        </UserContextProvider>
    )
}

const MainContainer = styled.div`
    background: var(--main-bg-color);
    min-height: 100vh;
`

export default App
